'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  &:before {\n    content: "";\n    width: 90%;\n    position: absolute;\n    right: 0;\n    top: 48%;\n    border-bottom: ', ';\n    transform: skewY(-10deg);\n  }\n'], ['\n  position: relative;\n  display: inline-block;\n  &:before {\n    content: "";\n    width: 90%;\n    position: absolute;\n    right: 0;\n    top: 48%;\n    border-bottom: ', ';\n    transform: skewY(-10deg);\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _GenericPrice = require('../../atoms/GenericPrice');

var _GenericPrice2 = _interopRequireDefault(_GenericPrice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  className: _propTypes2.default.string,
  size: _propTypes2.default.string,
  price: _propTypes2.default.number,
  color: _propTypes2.default.string,
  toFixDecimal: _propTypes2.default.number,
  currencySymbol: _propTypes2.default.string,
  strikeColor: _propTypes2.default.string,
  currencyAutoId: _propTypes2.default.string,
  strikePriceSrOnlyText: _propTypes2.default.string,
  bold: _propTypes2.default.bool
};

var defaultProps = {
  currencySymbol: '$',
  size: 'large',
  color: 'gray',
  toFixDecimal: 2,
  strikeColor: 'red'
};

var StrikedPrice = (0, _styledComponents2.default)(_GenericPrice2.default)(_templateObject, function (props) {
  return '1px solid ' + props.theme.colors[props.strikeColor];
});

var StrikePrice = function StrikePrice(_ref) {
  var className = _ref.className,
      size = _ref.size,
      price = _ref.price,
      color = _ref.color,
      toFixDecimal = _ref.toFixDecimal,
      currencySymbol = _ref.currencySymbol,
      strikeColor = _ref.strikeColor,
      currencyAutoId = _ref.currencyAutoId,
      bold = _ref.bold,
      strikePriceSrOnlyText = _ref.strikePriceSrOnlyText;
  return _react2.default.createElement(StrikedPrice, {
    currencyAutoId: currencyAutoId,
    className: className,
    strikeColor: strikeColor,
    isStrikePrice: true,
    size: size,
    color: color,
    price: price,
    toFixDecimal: toFixDecimal,
    currencySymbol: currencySymbol,
    bold: bold,
    strikePriceSrOnlyText: strikePriceSrOnlyText
  });
};

StrikePrice.propTypes = propTypes;
StrikePrice.defaultProps = defaultProps;

exports.default = StrikePrice;